import Console from './utils/Console';

(global as any).Console = new Console();
